import React from 'react'
import {Button} from "reactstrap";

const DeleteBatch=({deleteBatch,setDeleteModal})=> {
    
    const deleteRecord= ()=>{
        // console.log('data...',data,'id',data)
        setDeleteModal(false)
        deleteBatch()
    
    }

    const onclick= ()=>{
        setDeleteModal(false)
    }
    return (
    <div>
        <p >Do you want to delete this Batch</p>
        <div style={{display:'flex',flexDirection:'row'}}>
        <Button color='info' onClick={deleteRecord}>Yes</Button>
        <Button  onClick={onclick}>No</Button>
        </div>
    </div>
    )
}

export default DeleteBatch;
